/**
 * Mobile Mega Menu (auto-build from existing Mega Menu sections)
 * ------------------------------------------------------------
 * Zero Liquid changes required. Reads:
 *  - desktop nav links that already have [data-kk-mega-menu-trigger]
 *  - the .kk-mega-menu[data-kk-mega-menu] panels rendered by your
 *    "Mega Menu" sections (including their title icon/svg)
 * ...and builds a tabs + accordion UI inside the mobile drawer,
 * replacing the plain link list automatically.
 */
(function () {
  function normalize(str) {
    return (str || '').trim().toLowerCase();
  }

  function injectStyles() {
    if (document.getElementById('kk-mobile-mega-styles')) return;
    var style = document.createElement('style');
    style.id = 'kk-mobile-mega-styles';
    style.textContent = `
      .kk-mobile-mega__tabs {
        display: flex;
        gap: 24px;
        padding: 10px 0px 0px;
        border-bottom: 1px solid #eee;
        overflow-x: auto;
        margin-inline:10px;
        justify-content:space-around;
      }
      .kk-mobile-mega__tab {
        display: flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        padding: 0 0 0px;
        font-size: 14px;
        font-weight: 500;
        color: #6b6b6b;
        white-space: nowrap;
        cursor: pointer;
      }
      .kk-mobile-mega__tab.is-active {
        color: #159cd8;
        border-bottom-color: #159cd8;
        text-decoration:underline;
      }
      .kk-mobile-mega__tab .kk-mega-menu__title-icon {
        display: flex;
        align-items: center;
      }
      .kk-mobile-mega__tab .kk-mega-menu__title-icon img,
      .kk-mobile-mega__tab .kk-mega-menu__title-icon svg {
        width: 18px;
        height: 18px;
        display: block;
      }
      .kk-mobile-mega__panels {
        padding: 4px 10px 20px;
      }
      .kk-mobile-mega__panel[hidden] {
        display: none;
      }
      .kk-mobile-accordion__item {
        border-bottom: 1px solid #f0f0f0;
      }
      .kk-mobile-accordion__trigger {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: none;
        border: none;
        padding: 14px 0;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #1a1a1a;
        cursor: pointer;
        }
      .kk-mobile-accordion__trigger span{
        color:#00000059;
        }
      .is-open  .kk-mobile-accordion__trigger span{
        color:#159CD8;
        text-decoration:underline;
      }
      .kk-mobile-accordion__chevron {
        width: 10px;
        height: 7px;
        flex-shrink: 0;
        transition: transform 0.2s ease;
      }
      .kk-mobile-accordion__item.is-open .kk-mobile-accordion__chevron {
        transform: rotate(180deg);
      }
      .kk-mobile-accordion__content {
        display: none;
        flex-direction: column;
        padding-bottom: 8px;
      }
      .kk-mobile-accordion__item.is-open .kk-mobile-accordion__content {
        display: block;
        column-count:2;
      }
      .kk-mobile-accordion__content .kk-mega-menu__link {
        padding: 6px 0;
        font-size: 12px;
        letter-spacing:0.96px;
      }
      .kk-mobile-mega__panel .kk-mega-menu__featured {
        margin-top: 16px;
        max-width: none;
      }
      .kk-mobile-mega__panel .kk-mega-menu__usp {
        margin: 20px 0 0;
        border-radius: 8px;
        flex-direction: column;
        gap: 0;
        padding: 4px 10px;
      }
      .kk-mobile-mega__panel .kk-mega-menu__usp-item {
        padding: 12px 0;
        border-bottom: 1px solid #eaeaea;
      }
      .kk-mobile-mega__panel .kk-mega-menu__usp-item:last-child {
        border-bottom: none;
      }
      .kk-mobile-mega .kk-mega-menu__usp-item{
        min-width:100% !important;
        width:100%;
      }
      @media (min-width: 375px) {
        .kk-mobile-mega__panel .kk-mega-menu__usp {
          flex-direction: row;
          flex-wrap: wrap;
          gap: 0px 10px;
          display:grid;
          grid-template-columns: 1fr 1fr;
          width:100%;
        }
        .kk-mobile-mega__panel .kk-mega-menu__usp-item {
        //   width: calc(50% - 10px);
          border-bottom: none;
        }
          .kk-mobile-mega .kk-mega-menu__usp-text strong{
            font-size:12px !important;
          }
        .kk-mobile-mega .kk-mega-menu__usp-text span{
            font-size:10px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function buildMobileMega() {
    if (document.querySelector('[data-kk-mobile-mega]')) return; // already built

    var drawer = document.querySelector('#MenuDrawer');
    if (!drawer) return;

    var parentWrap = drawer.querySelector('[data-parent]');
    if (!parentWrap) return;

    var fallbackList = parentWrap.querySelector(':scope > ul');
    if (!fallbackList) return;

    var triggers = document.querySelectorAll('[data-kk-mega-menu-trigger]');
    var panels = document.querySelectorAll('.kk-mega-menu[data-kk-mega-menu]');
    if (!triggers.length || !panels.length) return;

    injectStyles();

    var container = document.createElement('div');
    container.className = 'kk-mobile-mega';
    container.setAttribute('data-kk-mobile-mega', '');

    var tabsWrap = document.createElement('div');
    tabsWrap.className = 'kk-mobile-mega__tabs';
    tabsWrap.setAttribute('data-kk-mobile-mega-tabs', '');

    var panelsWrap = document.createElement('div');
    panelsWrap.className = 'kk-mobile-mega__panels';
    panelsWrap.setAttribute('data-kk-mobile-mega-panels', '');

    container.appendChild(tabsWrap);
    container.appendChild(panelsWrap);

    var seenNames = {};
    var tabIndex = 0;

    triggers.forEach(function (trigger) {
      var title = trigger.getAttribute('data-kk-mega-menu-trigger');
      var normTitle = normalize(title);
      if (!normTitle || seenNames[normTitle]) return;

      var matchedPanel = null;
      panels.forEach(function (p) {
        if (normalize(p.getAttribute('data-kk-mega-menu')) === normTitle) {
          matchedPanel = p;
        }
      });
      if (!matchedPanel) return;

      seenNames[normTitle] = true;
      tabIndex++;
      var tabId = 'kk-mobile-tab-' + tabIndex;

      // --- Tab button (icon + label, pulled straight from the panel header) ---
      var tabBtn = document.createElement('button');
      tabBtn.type = 'button';
      tabBtn.className = 'kk-mobile-mega__tab';
      tabBtn.setAttribute('data-tab-target', tabId);

      var iconEl = matchedPanel.querySelector('.kk-mega-menu__title-icon');
      if (iconEl) {
        tabBtn.appendChild(iconEl.cloneNode(true));
      }

      var labelSpan = document.createElement('span');
      labelSpan.textContent = title;
      tabBtn.appendChild(labelSpan);

      tabsWrap.appendChild(tabBtn);

      // --- Panel ---
      var panelEl = document.createElement('div');
      panelEl.className = 'kk-mobile-mega__panel';
      panelEl.id = tabId;
      panelEl.hidden = true;

      var accordion = document.createElement('div');
      accordion.className = 'kk-mobile-accordion';

      var columns = matchedPanel.querySelectorAll('.kk-mega-menu__column');
      var columns = matchedPanel.querySelectorAll('.kk-mega-menu__column');
columns.forEach(function (col, colIdx) {
  var headings = col.querySelectorAll('.kk-mega-menu__col-heading');

  // If the heading is wrapped in <a> (label_link), treat the <a> as the heading node
  function headNodeOf(h) {
    return h && h.parentElement && h.parentElement.tagName === 'A' ? h.parentElement : h;
  }

  headings.forEach(function (heading, hIdx) {
    var headNode = headNodeOf(heading);
    var nextHeadNode = headNodeOf(headings[hIdx + 1]) || null;
    var headingText = heading.textContent.trim();
    var href = headNode.tagName === 'A' ? headNode.getAttribute('href') : null;

    // 1. Collect sub-links
    var contentWrap = document.createElement('div');
    contentWrap.className = 'kk-mobile-accordion__content';

    function addLink(node) {
      contentWrap.appendChild(node.cloneNode(true));
    }

    var el = headNode.nextElementSibling;
    while (el && el !== nextHeadNode) {
      if (el.classList.contains('kk-mega-menu__link')) {
        addLink(el);
      } else {
        el.querySelectorAll('.kk-mega-menu__link').forEach(addLink);
      }
      el = el.nextElementSibling;
    }

    // Overflow links from the next desktop column
    var blockId = heading.getAttribute('data-block-id');
    if (blockId) {
      matchedPanel
        .querySelectorAll('[data-overflow-for="' + blockId + '"] .kk-mega-menu__link')
        .forEach(addLink);
    }

    // 2. No submenu -> plain row (linked if label_link exists)
    if (!contentWrap.children.length) {
      var plain = document.createElement('div');
      plain.className = 'kk-mobile-accordion__item kk-mobile-accordion__item--plain';

      var a = document.createElement(href ? 'a' : 'span');
      a.className = 'kk-mobile-accordion__link';
      if (href) a.setAttribute('href', href);
      a.textContent = headingText;

      plain.appendChild(a);
      accordion.appendChild(plain);
      return;
    }

    // 3. Has submenu -> accordion
    var item = document.createElement('div');
    item.className = 'kk-mobile-accordion__item ' + (colIdx == 0 ? 'is-open' : '');
    item.innerHTML =
      '<button type="button" class="kk-mobile-accordion__trigger">' +
        '<span></span>' +
        '<svg class="kk-mobile-accordion__chevron" xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">' +
        '<path d="M9.75 5.00346L5.25 1.00346L0.75 5.00346" stroke="black" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>';
    item.querySelector('.kk-mobile-accordion__trigger span').textContent = headingText;

    // Heading has its own link AND a submenu: the button can't be a link,
    // so add a "View all" row at the top of the dropdown
    if (href) {
      var all = document.createElement('a');
      all.className = 'kk-mega-menu__link kk-mobile-accordion__viewall';
      all.setAttribute('href', href);
      all.textContent = 'View all';
      contentWrap.insertBefore(all, contentWrap.firstChild);
    }

    item.appendChild(contentWrap);
    accordion.appendChild(item);
  });
});

      panelEl.appendChild(accordion);

      var featured = matchedPanel.querySelector('.kk-mega-menu__featured');
      if (featured) panelEl.appendChild(featured.cloneNode(true));

      var usp = matchedPanel.querySelector('.kk-mega-menu__usp');
      if (usp) panelEl.appendChild(usp.cloneNode(true));

      panelsWrap.appendChild(panelEl);
    });

    if (!tabIndex) return;

    var firstTab = tabsWrap.querySelector('.kk-mobile-mega__tab');
    var firstPanel = panelsWrap.querySelector('.kk-mobile-mega__panel');
    if (firstTab && firstPanel) {
      firstTab.classList.add('is-active');
      firstPanel.hidden = false;
    }

    tabsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.kk-mobile-mega__tab');
      if (!btn) return;
      tabsWrap.querySelectorAll('.kk-mobile-mega__tab').forEach(function (t) {
        t.classList.remove('is-active');
      });
      panelsWrap.querySelectorAll('.kk-mobile-mega__panel').forEach(function (p) {
        p.hidden = true;
      });
      btn.classList.add('is-active');
      document.getElementById(btn.getAttribute('data-tab-target')).hidden = false;
    });

    panelsWrap.addEventListener('click', function (e) {
      var trig = e.target.closest('.kk-mobile-accordion__trigger');
      if (!trig) return;
      var item = trig.closest('.kk-mobile-accordion__item');
      var isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.kk-mobile-accordion__item').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!isOpen) item.classList.add('is-open');
    });

    parentWrap.insertBefore(container, fallbackList);
    fallbackList.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildMobileMega);
  } else {
    buildMobileMega();
  }
})();